module.exports = __webpack_public_path__ + "img/sorting_a2_example.b40c4803.png";